// =============================================================================
// Operators & Conditions (matching data_reports.types.ts)
// =============================================================================
export var Operator;
(function (Operator) {
    Operator["GreaterThan"] = ">";
    Operator["GreaterThanOrEqual"] = ">=";
    Operator["LessThan"] = "<";
    Operator["LessThanOrEqual"] = "<=";
    Operator["Equal"] = "=";
    Operator["NotEqual"] = "!=";
    Operator["Contains"] = "contains";
    Operator["NotSet"] = "notSet";
})(Operator || (Operator = {}));
